export var NodeIconType;
(function (NodeIconType) {
    NodeIconType[NodeIconType["EXCAVATOR"] = 0] = "EXCAVATOR";
    NodeIconType[NodeIconType["TRACTOR"] = 1] = "TRACTOR";
    NodeIconType[NodeIconType["POWER"] = 2] = "POWER";
    NodeIconType[NodeIconType["BATTERY"] = 3] = "BATTERY";
    NodeIconType[NodeIconType["ESS"] = 4] = "ESS";
    NodeIconType[NodeIconType["ESSBOX"] = 5] = "ESSBOX";
    NodeIconType[NodeIconType["TRUCKWITHESS"] = 6] = "TRUCKWITHESS";
    NodeIconType[NodeIconType["WARNING"] = 7] = "WARNING";
    NodeIconType[NodeIconType["CAT950"] = 8] = "CAT950";
    NodeIconType[NodeIconType["IDLEMECCHARGER"] = 9] = "IDLEMECCHARGER";
    NodeIconType[NodeIconType["CHARGEMECCHARGER"] = 10] = "CHARGEMECCHARGER";
    NodeIconType[NodeIconType["WHEELLOADER"] = 11] = "WHEELLOADER";
    NodeIconType[NodeIconType["METHANOL_REFORMER"] = 12] = "METHANOL_REFORMER";
    NodeIconType[NodeIconType["GHOST_MACHINE"] = 13] = "GHOST_MACHINE";
})(NodeIconType || (NodeIconType = {}));
export var NodeIconColor;
(function (NodeIconColor) {
    NodeIconColor["CHARGING"] = "network-green";
    NodeIconColor["DISCHARGING"] = "network-orange";
    NodeIconColor["FAULTED"] = "network-dark-red";
    NodeIconColor["IDLE"] = "network-blue";
    NodeIconColor["INACTIVE"] = "network-grey";
    NodeIconColor["NOT_REPORTING"] = "network-not-reporting";
    NodeIconColor["OCCUPIED"] = "network-occupied";
    NodeIconColor["OFF"] = "network-off-grey";
    NodeIconColor["SELF_DISCHARGE"] = "network-moderate-blue";
    NodeIconColor["TRANSPORTING"] = "network-pink";
    NodeIconColor["TRICKLE"] = "network-cyan";
    NodeIconColor["UNAVAILABLE"] = "network-unavailable-grey";
    NodeIconColor["WORKING"] = "network-strong-blue";
})(NodeIconColor || (NodeIconColor = {}));
